import http from '@/utils/http';

const baseUrl = '/central-eventos';

export default {
    buscarEventos() {
        return http.get({
            url: baseUrl + `/buscar`,
            lockScreen: false
        });
    }
};
